define([
  'angular',
  'mod',
  'common/Utils'
], function(angular, mod) {


require('common/Notifications/notifications.scss');

var m = require('am');

m.factory('notify', ['hash', '$timeout', function(hash, $timeout) {
  /*
  notify("Hello World") // A default notification
  notify.error("Oh noes!") or notify("Oh noes!", {type: 'error'}) // With a type of "error"
  notify("Self destructing!", {timeout: 5000}) // Disappears after 5 seconds
  notify("Icons!", {icon: 'K'}) // Set a custom icon
  */
  var current = [];
  function add(message, options) {
    var id = hash(message);
    var opt = _.defaults(options || {}, {icon: 'k', type: 'notification'});

    if (_.isObject(message)) {
      if (message.status >= 400) {
        opt.type = 'error';
      }
      opt.message = (message.data && message.data.message || message.data || message);
      try {
        opt.message = angular.fromJson(opt.message);
      } catch(e) {}
    } else {
      opt.message = message;
    }

    function close() {
      var index = _.findIndex(current, function(item) {
        return item._id === id;
      });
      if ( index !== -1 ) {
        current.splice(index, 1);
      }
    }
    opt = _.assign(opt || {}, {
      _id: id,
      close: close
    });
    current.push(opt);
    if(opt.timeout > 0){
      $timeout(close, opt.timeout);
    }
    return close;
  }
  Object.defineProperty(add, 'current', {
    get: function() {
      return current;
    }
  });

  _.each({
    notification: {},
    error: {type: 'error'}
  }, function(preset, name) {
    add[name] = function(message, options) {
      return add(message, _.defaults(options, preset));
    };
  });

  return add;
}]);

m.directive('notifications', ['notify', function(notify) {
  return {
    replace: true,
    templateUrl: require('common/Notifications/notifications.html'),
    controller: ['$scope', function($scope) {
      $scope.items = notify.current;
    }]
  };
}]);

return m;
});



/** WEBPACK FOOTER **
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/Notifications/Notifications.js
 **/